/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Fluffy_Fish_DevourInputs */

const fr_safe_fluffy_fish_devour = /** @type {(inputs: Safe_Fluffy_Fish_DevourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions / tour`)
};

/**

* @param {Safe_Fluffy_Fish_DevourInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const safe_fluffy_fish_devour = /** @type {((inputs?: Safe_Fluffy_Fish_DevourInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Fluffy_Fish_DevourInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_safe_fluffy_fish_devour(inputs)
});